module.exports = __webpack_public_path__ + "static/media/word-file.3c3232b5.svg";